import { DateTime } from 'luxon';

import Day from './Day';

export default class Hour {
  constructor(
    public day: Day,
    public hour: number,
    public isSelected = false,
    public isStateTemporary = false,
  ) {}

  get label() {
    return DateTime.local().startOf('day').plus({ hours: this.hour }).toLocaleString(DateTime.TIME_SIMPLE);
  }

  get compactLabel() {
    const isUsingAnteMeridiems = DateTime.local().toLocaleString(DateTime.TIME_SIMPLE).includes('M'); // Check if AM/PM is used.
    const format = isUsingAnteMeridiems ? 'h' : 'HH';
    const frag = DateTime.local().startOf('day').plus({ hours: this.hour }).toFormat(format);
    return frag;
  }

  get compactLabelSuffix() {
    const isUsingAnteMeridiems = DateTime.local().toLocaleString(DateTime.TIME_SIMPLE).includes('M'); // Check if AM/PM is used.
    const format = isUsingAnteMeridiems ? 'a' : '';
    const frag = format !== '' ? DateTime.local().startOf('day').plus({ hours: this.hour }).toFormat(format) : '';
    return frag;
  }

  get className() {
    return this.isSelected ? 'selected' : '';
  }

  clone(day = null) {
    return new Hour(day == null ? this.day : day, this.hour, this.isSelected);
  }
}
